const TOWNSHIP_TOOLTIP_COOKIE_NAME = 'township_tooltip';
const SHOW_TOOLTIP_CLASS = 'show';

let $body;
let $townshipTooltip;
let $townshipFader;

function toggleTooltipClasses() {
    $body.toggleClass('township-tooltip');
    $townshipTooltip.toggleClass(SHOW_TOOLTIP_CLASS);
    $townshipFader.toggleClass(SHOW_TOOLTIP_CLASS);
}

function initTooltip() {
    if (!getCookie(TOWNSHIP_TOOLTIP_COOKIE_NAME)) {
        setCookie(
            TOWNSHIP_TOOLTIP_COOKIE_NAME,
            true
        );
        toggleTooltipClasses();
    }
}

$(document).ready(() => {
    $body = $('body');
    $townshipTooltip = $('.js-township-tooltip');
    $townshipFader = $('.js-township-fader');

    initTooltip();
});
